import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TakeOffConfig } from '../feat-take-off-v2/domain';

@Component({
    selector: 'app-take-off-v2-actions',
    templateUrl: './take-off-v2-actions.component.html',
    styleUrls: ['./take-off-v2-actions.component.scss'],
    standalone: false,
})
export class TakeOffV2ActionsComponent {
    // @ts-ignore TS2564
    @Input() config: TakeOffConfig;
    // @ts-ignore TS2564
    @Input() hasDrawings: boolean;

    @Output() undoChanges = new EventEmitter();
    @Output() removeAllChanges = new EventEmitter();
    @Output() dismissChanges = new EventEmitter();

    constructor() {}

    public onUndo() {
        this.undoChanges.emit();
    }

    public onRemoveAll() {
        this.removeAllChanges.emit();
    }

    public onDismiss() {
        this.dismissChanges.emit();
    }
}

@NgModule({
    declarations: [TakeOffV2ActionsComponent],
    imports: [CommonModule, TooltipModule],
    exports: [TakeOffV2ActionsComponent],
})
export class TakeOffV2ActionsModule {}
